export default Object.freeze({
  Processed: 0,
  Dropped: 1,
  Delivered: 2,
  Bounce: 3,
  Deferred: 4,
  Open: 5,
  Click: 6,
  Unsubscribe: 7,
  Resubscribe: 8,
  SpamReport: 9,
});
